import { Select } from 'antd';
import { SelectValue } from "antd/lib/select";
import { observer } from 'mobx-react';
import React, { useEffect } from "react";
import SourceFilterStore from '../../../stores/common/source-filter';
import './style.css';

const { Option } = Select;

const SourceFilter: React.FC<{ source: SourceFilterStore }> = ({ source }) => {

    const handleChange = (value: SelectValue) => {
        if (source.multiple) {
            source.selectItem(value as string[]);
        } else {
            source.selectItem([value as string]);
        }
    };

    useEffect(() => { source.loadDictionary() }, [source]);

    return (
        <Select
            mode={source.multiple === true ? "multiple" : undefined}
            placeholder="источник"
            optionLabelProp="label"
            onChange={handleChange}
            className="filter__item"
            value={source.selectedItems}
        >
            {source.items?.map((i) => <Option key={i.id} value={i.id} label={i.name}>{i.name}</Option>)}
        </Select>
    );
};


export default observer(SourceFilter);